import PropTypes from 'prop-types';
import React from 'react';
import QcardHeader from '_Components/QcardPanel/QcardHeader/QcardHeader';
import CModal from '../../CModal/CModal';
import { BasePropTypes, TemplatePropTypes } from '../../../_Utils/common.propTypes';

const QModal = ({
  children,
  className,
  title,
  exportReportModal,
  logo,
  isOpen,
  onClose,
  subtitle,
  footer,
  config,
  hideFooter,
  data,
  size,
  buttonRight,
}) => {
  const { mentions, date } = config;

  const getCustomHeader = () => {
    if (exportReportModal) {
      return (
        <div>
          <div
            style={{
              display: 'inline-block',
              position: 'absolute',
              top: '16px',
              right: '24px',
              height: '36px',
              width: '36px',
            }}
          >
            {logo}
          </div>
          <QcardHeader title={title} displayCardSubTitle={false} />
        </div>
      );
    }
    return undefined;
  };

  return (
    <CModal
      className={className}
      data={data}
      customHeader={getCustomHeader()}
      displayMentionsSubtitle={mentions}
      displayDateSubtitle={date}
      subtitleAdditionalContent={subtitle}
      footer={footer}
      modal={isOpen}
      toggle={onClose}
      hideFooter={hideFooter}
      size={size}
      buttonRight={buttonRight}
    >
      {children}
    </CModal>
  );
};

QModal.propTypes = {
  ...BasePropTypes,

  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,

  subtitle: PropTypes.string,
  footer: TemplatePropTypes,
  config: PropTypes.shape({
    mentions: PropTypes.bool,
    date: PropTypes.bool,
  }),

  data: PropTypes.objectOf(PropTypes.any),
};

QModal.defaultProps = {
  subtitle: null,
  footer: null,
  config: {},
  data: {},
};

export default QModal;
